
<script>
import datefield from './js'
export default datefield
</script>

<style scoped>
@import './scss/datefield.scss';
</style>
